import { request } from "./request";

export function queryPatent(startIndex, length) {
  return request({
    url: '/patent/queryPatent',
    params:{
      startIndex,
      length
    }
  })
}

export function totalPatent() {
  return request({
    url:'/patent/totalPatent',
  })
}

export function insert(year, patentName, patentOwner, patentNumber, patentCountry) {
  return request({
    url: '/patent/insertPatent',
    params: {
      year, patentName, patentOwner, patentNumber, patentCountry
    }
  })
}

export function modifyPatent(id, year, patentName, patentOwner, patentNumber, patentCountry) {
  return request({
    url: '/patent/modifyPatent',
    params: {
      id, year, patentName, patentOwner, patentNumber, patentCountry
    }
  })
}

export function deletePatent(id) {
  return request({
    url: 'patent/deletePatent',
    params: { id }
  })
}